<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-margin-top-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Filters
    </Teleport>

    <div
      v-for="group in filterAttributes.groups"
      :key="group.type"
    >
      <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-8">
        <h3 class="cf-title cf-title--3">
          {{ group.title }}
        </h3>

        <p
          v-if="group.description"
          class="cf-subtitle cf-subtitle--2"
        >
          {{ group.description }}
        </p>
      </div>

      <div class="cf-checkbox-group no-spacing">
        <div class="cf-checkbox-group__items">
          <div
            v-for="attribute in group.attributes"
            :key="attribute.id"
            class="cf-checkbox-group__item"
          >
            <input
              :id="attribute.id"
              class="cf-checkbox-group__input"
              type="checkbox"
              :name="attribute.id"
              :checked="selectedFilterIds.includes(attribute.id)"
              @input="filterCheckboxInputHandler(attribute, $event)"
            >

            <label
              class="cf-checkbox-group__label"
              :for="attribute.id"
            >
              <img
                v-if="attribute.imageUrl"
                class="cf-image-icon cf-image--24"
                :src="attribute.imageUrl"
                :alt="attribute.name"
              >

              <span class="cf-checkbox-group__label-title">
                {{ attribute.name }}
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-modal__footer cf-modal__footer--sticky">
      <button
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        type="button"
        @click="applyFilters"
      >
        Apply Filters
      </button>

      <button
        type="button"
        class="cf-button cf-button--tertiary cf-button--lg cf-button--fill"
        @click="clearFilters"
      >
        Reset
      </button>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'MenuFilterModal',

    data() {
      return {
        selectedFilterIds: []
      };
    },

    computed: {
      ...mapGetters('menu', ['filterAttributes'])
    },

    watch: {
      filterAttributes: 'onWatchFilterAttributes'
    },

    methods: {
      applyFilters() {
        this.$store.dispatch('menu/updateSelectedFilters', this.selectedFilterIds);

        this.$closeModal('menuListFilterModal');
      },

      clearFilters() {
        this.$store.dispatch('menu/updateSelectedFilters', []);

        this.$closeModal('menuListFilterModal');
      },

      onWatchFilterAttributes() {
        this.selectedFilterIds = [];

        this.filterAttributes.selected.forEach((attribute) => {
          this.selectedFilterIds.push(attribute.id);
        });
      },

      filterCheckboxInputHandler(attribute, event) {
        const isSelected = event.target.checked;

        if (isSelected) {
          this.selectedFilterIds.push(attribute.id);
        }

        else {
          this.selectedFilterIds = this.selectedFilterIds.filter(id => id !== attribute.id);
        }
      }
    }
  };
</script>
